import type {ReactElement} from 'react';
import {SignupOnly} from '@FormMakerReact/layout/form-maker-right-panel/components/signup-only/signup-only';
import {DescriptionToggleRow} from '@FormMakerReact/layout/form-maker-right-panel/controls/description-toggle-control/description-toggle-control';
import type {FormBackgroundDescriptionToggleControlProps} from './form-background-description-toggle-control.types';

export function FormBackgroundDescriptionToggleControl({component}: FormBackgroundDescriptionToggleControlProps): ReactElement | null {
  return (
    <SignupOnly component={component}>
      <DescriptionToggleRow />
    </SignupOnly>
  );
}
